import { render, staticRenderFns } from "./ot-data-driven-claim-form.vue?vue&type=template&id=c5d204a8&scoped=true&"
import script from "./ot-data-driven-claim-form.vue?vue&type=script&lang=ts&"
export * from "./ot-data-driven-claim-form.vue?vue&type=script&lang=ts&"
import style0 from "./ot-data-driven-claim-form.vue?vue&type=style&index=0&id=c5d204a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d204a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
